import { SuggestedPrompt } from "../../../chat.type";

// Suggested Prompts
export const suggestedPrompts: SuggestedPrompt[] = [
  {
    model: "SailPointIAMOperations",
    prompts: [
      { button: "Today's Tickets", prompt: "What are my priorities for today?" },
      { button: "View Ticket", prompt: "I would like to view information on this ticket: " },
      { button: "Detailed Resolution Steps", prompt: "Give me more information about this ticket and give me detailed steps to resolve the issue." },
      {
        button: "Create Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Ticket ID",
              name: "ticketId",
              textboxPlaceholder: "Ticket ID",
              type: "text",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              textboxPlaceholder: "What was the root cause?",
              type: "text",
            },
            {
              label: "Resolution Steps",
              name: "resolutionSteps",
              textboxPlaceholder: "How was the issue resolved?",
              type: "text",
            },
            {
              label: "Future Mitigation Steps",
              name: "mitigationSteps",
              textboxPlaceholder: "Steps taken to prevent in future?",
              type: "text",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nTicket ID: ${data.ticketId}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      },
      { button: "Landscape & Health", prompt: "Give me a health report report of past tickets with percentages, highlighting environment health and trends." }
    ],
  },
  {
    model: "CyberArkIAMOperations",
    prompts: [
      { button: "Today's Tickets", prompt: "What are my priorities for today?" },
      { button: "View Ticket", prompt: "I would like to view information on this ticket: " },
      { button: "Detailed Resolution Steps", prompt: "Give me more information about this ticket and give me detailed steps to resolve the issue." },
      {
        button: "Create Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Ticket ID",
              name: "ticketId",
              textboxPlaceholder: "Ticket ID",
              type: "text",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              textboxPlaceholder: "What was the root cause?",
              type: "text",
            },
            {
              label: "Resolution Steps",
              name: "resolutionSteps",
              textboxPlaceholder: "How was the issue resolved?",
              type: "text",
            },
            {
              label: "Future Mitigation Steps",
              name: "mitigationSteps",
              textboxPlaceholder: "Steps taken to prevent in future?",
              type: "text",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nTicket ID: ${data.ticketId}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      },
      { button: "Landscape & Health", prompt: "Give me a health report report of past tickets with percentages, highlighting environment health and trends." }
    ],
  },
  {
    model: "CyberArkOpsAsst",
    prompts: [
      { button: "Today's Tickets", prompt: "What are my priorities for today?" },
      { button: "Detailed Resolution Steps", prompt: "Give me more information about this ticket and give me detailed steps to resolve the issue." },
      { button: "Landscape & Health", prompt: "Give me a report of past tickets with percentages, highlighting environment health and trends." },
      {
        button: "Create Ticket Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Ticket ID",
              name: "ticketId",
              textboxPlaceholder: "Ticket ID",
              type: "text",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              textboxPlaceholder: "What was the root cause?",
              type: "text",
            },
            {
              label: "Resolution Steps",
              name: "resolutionSteps",
              textboxPlaceholder: "How was the issue resolved?",
              type: "text",
            },
            {
              label: "Future Mitigation Steps",
              name: "mitigationSteps",
              textboxPlaceholder: "Steps taken to prevent in future?",
              type: "text",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nTicket ID: ${data.ticketId}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      }
    ],
  },
  {
    model: "iam_jobaid",
    prompts: [
      {
        button: "Help me resolve this issue",
        prompt: "Help me resolve this issue:",
        form: {
          title: "Issue Description",
          fields: [
            {
              label: "Ticket/Issue Description",
              name: "issueDescription",
              type: "textarea",
              textboxPlaceholder: "What issue was reported?",
            }
          ],
          textOutput: (data) =>
            `Give me more information about this ticket and give me detailed steps to resolve the issue. Issue: ${data.issueDescription}`,
          submitLabel: "Generate Writeup",
        },
      },
      {
        button: "Create Ticket Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Issue Description",
              name: "issueDescription",
              type: "text",
              textboxPlaceholder: "What issue was reported?",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              type: "text",
              textboxPlaceholder: "What was the root cause?",
            },
            {
              label: "Resolution",
              name: "resolutionSteps",
              type: "text",
              textboxPlaceholder: "How was the issue resolved?",
            },
            {
              label: "Mitigation",
              name: "mitigationSteps",
              type: "text",
              textboxPlaceholder: "Steps taken to prevent in future?",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nIssue: ${data.issueDescription}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      }
    ],
  },
  {
    model: "OktaOpsAsst",
    prompts: [
      { button: "Today's Tickets", prompt: "What are my priorities for today?" },
      { button: "Detailed Resolution Steps", prompt: "Give me more information about this ticket and give me detailed steps to resolve the issue." },
      { button: "Landscape & Health", prompt: "Give me a report of past tickets with percentages, highlighting environment health and trends." },
      {
        button: "Create Ticket Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Ticket ID",
              name: "ticketId",
              textboxPlaceholder: "Ticket ID",
              type: "text",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              textboxPlaceholder: "What was the root cause?",
              type: "text",
            },
            {
              label: "Resolution Steps",
              name: "resolutionSteps",
              textboxPlaceholder: "How was the issue resolved?",
              type: "text",
            },
            {
              label: "Future Mitigation Steps",
              name: "mitigationSteps",
              textboxPlaceholder: "Steps taken to prevent in future?",
              type: "text",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nTicket ID: ${data.ticketId}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      }
    ],
  },
  {
    model: "SailPointOpsAsst",
    prompts: [
      { button: "Today's Tickets", prompt: "What are my priorities for today?" },
      { button: "Detailed Resolution Steps", prompt: "Give me more information about this ticket and give me detailed steps to resolve the issue." },
      { button: "Landscape & Health", prompt: "Give me a report of past tickets with percentages, highlighting environment health and trends." },
      {
        button: "Create Ticket Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Ticket ID",
              name: "ticketId",
              textboxPlaceholder: "Ticket ID",
              type: "text",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              textboxPlaceholder: "What was the root cause?",
              type: "text",
            },
            {
              label: "Resolution Steps",
              name: "resolutionSteps",
              textboxPlaceholder: "How was the issue resolved?",
              type: "text",
            },
            {
              label: "Future Mitigation Steps",
              name: "mitigationSteps",
              textboxPlaceholder: "Steps taken to prevent in future?",
              type: "text",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nTicket ID: ${data.ticketId}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      }
    ],
  },
  {
    model: "Saviynt",
    prompts: [
      { button: "Today's Tickets", prompt: "What are my priorities for today?" },
      { button: "Detailed Resolution Steps", prompt: "Give me more information about this ticket and give me detailed steps to resolve the issue." },
      { button: "Landscape & Health", prompt: "Give me a report of past tickets with percentages, highlighting environment health and trends." },
      {
        button: "Create Ticket Closure Summary",
        form: {
          title: "Create Ticket Closure Summary",
          fields: [
            {
              label: "Ticket ID",
              name: "ticketId",
              textboxPlaceholder: "Ticket ID",
              type: "text",
            },
            {
              label: "Root Cause",
              name: "rootCause",
              textboxPlaceholder: "What was the root cause?",
              type: "text",
            },
            {
              label: "Resolution Steps",
              name: "resolutionSteps",
              textboxPlaceholder: "How was the issue resolved?",
              type: "text",
            },
            {
              label: "Future Mitigation Steps",
              name: "mitigationSteps",
              textboxPlaceholder: "Steps taken to prevent in future?",
              type: "text",
            },
          ],
          textOutput: (data) =>
            `Ticket Closure Summary:\nTicket ID: ${data.ticketId}\nRoot Cause: ${data.rootCause}\nResolution: ${data.resolutionSteps}\nMitigation Steps: ${data.mitigationSteps}`,
          submitLabel: "Generate Writeup",
        },
      }
    ]
  },
  {
    model: "zerotrustsase",
    prompts: [
      { button: "Sample questions", prompt: "What are some questions I can ask you?" },
      { button: "Project roadmap", prompt: "Hello, I would like to generate a project roadmap for a new project." },
      { button: "Project requirements", prompt: "Hello, I would like to generate a project requirements document for a new project." },
      {
        button: "Review materials",
        prompt: "I would like to review the materials for a project can you help me?",
      }
    ],
  },
  {
    model: "SAPMatrix",
    prompts: [
      {
        button: "Create Auth Matrix",
        form: {
          title: "Create Authorization Matrix",
          fields: [
            {
              label: "Authorization Matrix",
              name: "authorizationMatrix",
              type: "checkbox",
              defaultChecked: true,
              showFieldsOnCheck: [
                {
                  label: "Business Process",
                  name: "businessProcessTop",
                  type: "checkbox",
                  defaultChecked: true,
                  showFieldsOnUncheck: [
                    {
                      label: "L1",
                      name: "l1",
                      type: "checkbox",
                      defaultChecked: true,
                      showFieldsOnCheck: [
                        {
                          label: "Filter L1",
                          name: "l1Filter",
                          type: "text",
                          textboxPlaceholder: "e.g., Record to Report (RTR)"
                        }
                      ]
                    },
                    {
                      label: "L2",
                      name: "l2",
                      type: "checkbox",
                      defaultChecked: true,
                      showFieldsOnCheck: [
                        {
                          label: "Filter L2",
                          name: "l2Filter",
                          type: "text",
                          textboxPlaceholder: "e.g., Treasury"
                        }
                      ]
                    },
                    {
                      label: "L3",
                      name: "l3",
                      type: "checkbox",
                      defaultChecked: true,
                      showFieldsOnCheck: [
                        {
                          label: "Filter L3",
                          name: "l3Filter",
                          type: "text",
                          textboxPlaceholder: "e.g., Cash Management"
                        }
                      ]
                    },
                    {
                      label: "L4",
                      name: "l4",
                      type: "checkbox",
                      defaultChecked: true,
                      showFieldsOnCheck: [
                        {
                          label: "Filter L4",
                          name: "l4Filter",
                          type: "text",
                          textboxPlaceholder: "e.g., Cash Operations"
                        }
                      ]
                    },
                  ]
                },

              ]
            }
          ],
          textOutput: (data) =>
            `Authorization Matrix:
            - Authorization Matrix: ${data.authorizationMatrix ? "Yes" : "No"}
            ${data.authorizationMatrix ? `- Business Process (Top): ${data.businessProcessTop ? "Yes" : "No"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- L1: ${data.l1 ? "Yes" : "No"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data.l1 && data.l1Filter_textbox ? `- Filter L1: ${data.l1Filter_textbox}` : ""}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- L2: ${data.l2 ? "Yes" : "No"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data.l2 && data.l2Filter_textbox ? `- Filter L2: ${data.l2Filter_textbox}` : ""}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- L3: ${data.l3 ? "Yes" : "No"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data.l3 && data.l3Filter_textbox ? `- Filter L3: ${data.l3Filter_textbox}` : ""}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- L4: ${data.l4 ? "Yes" : "No"}` : ""}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${data.l4 && data.l4Filter_textbox ? `- Filter L4: ${data.l4Filter_textbox}` : ""}
           `,
          submitLabel: "Generate Authorization Matrix"

        }
      }
    ]
  }
];